import React, { Component } from 'react';
import { connect } from "react-redux";
import { BrowserRouter as Router, Redirect, Switch, Route } from 'react-router-dom';
import store from './store';
import { DASHBOARD_MENU, LOGIN_STATUS as loginStat, USER_ROLES_ID as userRoles, NODE_ENVIRONMENTS as nodeEnv } from './utils/constant.utils';
import { trueFalseToBoolean } from './utils/helpers.utils';
import { setAuthToken } from './utils/api.utils'

import CallbackPage from './components/common/login/callback.component';
import ExternalAuthentication from './components/common/login/external-authentication.component';
import ExternalRedirectAuthentication from './components/common/login/external-redirect-authentication.component';
import Login from './components/common/login/login-container.component';
import SilentRenewCallback from './components/common/login/silent-renew-callback.component';
import InvalidAccess from './components/common/login/invalid-access.component';
import PageNotFound from './components/common/login/page-not-found.component';
import LogOut from './components/common/login/logout.component';
import ExternalRoutes from './routes/external-layout.route';
import InternalRoutes from './routes/internal-layout.route';

import ExternalLayout from './components/external/external-layout.component';

export class _Routes extends Component {
    render(){
        const { externalUser, isSsoEnabled, isDevEnv, user, history } = this.props;
        const logInStatus = sessionStorage.getItem('logInStatus') || localStorage.getItem('loginStatus');
        const hasToken = localStorage.getItem('access_token') !== null;

        if (logInStatus === loginStat.internal && hasToken) {
            return (
                <div>
                    <InternalRoutes />
                </div>
                )
        }

        if (logInStatus === loginStat.external && hasToken){
            if (externalUser !== null && Object.keys(externalUser).length > 0) {
                var access_token = isSsoEnabled && !this.props.isLoadingUser ? user.access_token : sessionStorage.getItem('access_token');
                var isManagerAdmin = [userRoles.manager, userRoles.admin].includes(parseInt(sessionStorage.UserRoleID));
                const isQuotationRequestEnabled = JSON.parse(sessionStorage.getItem('IsEnabledQuotationRequest')); 
                setAuthToken(access_token);
                return  (
                    <div>
                        <ExternalRoutes 
                            isManagerAdmin = {isManagerAdmin}
                            isQuotationRequestEnabled={isQuotationRequestEnabled}
                            history={history}
                            />
                    </div>
                );
            }
        }
        else
        {
            return(
                <div>
                    { isSsoEnabled && !isDevEnv 
                        ?<ExternalLayout isUserLoggedIn={user !== null && sessionStorage.User != null}>
                            <Route path="/external" component={Login} />
                        </ExternalLayout>
                        : <Route path="/external" component={Login} />
                    }
                </div>
            );
        }

        return <div> </div>;
    }
}
function mapStateToProps(state) {
    const logInStatus =
        sessionStorage.getItem('logInStatus') ||
        localStorage.getItem('logInStatus');

    return {
        ...state.authentication,
        ...state.location,
        isLoadingUser: state.oidc.isLoadingUser,

        user: logInStatus === loginStat.external
            ? state.oidc.user
            : logInStatus === loginStat.internal
                ? !trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE)
                    ? state.userTestHarness
                    : state.oidc.user
                : null,

        externalUser: state.authentication.user,
        isSsoEnabled: trueFalseToBoolean(
            process.env.REACT_APP_AAD_AUTH_ENABLE
        ),
        authentication: state.authentication,
        isDevEnv: process.env.NODE_ENV === nodeEnv.dev
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

const Routes = connect(
    mapStateToProps,
    mapDispatchToProps
)(_Routes);



export default (
    <Router>
        <Route path="/silentrenew" component={SilentRenewCallback} />
        <Route path="/callback" component={CallbackPage} />
        <Route path="/external" component={ExternalAuthentication} />
        <Route exact path="/" render={() => <Redirect to={{ pathname: '/userlogin' }} />} />
        <Switch>
            {
                (sessionStorage.getItem('access_token') === null && localStorage.getItem('access_token') === null) || (store.getState().oidc.user !== null && !store.getState().oidc.isLoadingUser)
                    ? <Route exact path="/userlogin" component={Login} />
                    : <Route exact path="/userlogin" render={() => <Redirect to={{ pathname: sessionStorage.getItem('logInStatus') === loginStat.internal ? '/internal' : '/external' }} />} />
            }
            <Route path="/redirectexternal" component={ExternalRedirectAuthentication} />
            <Route path="/external" component={Routes} />
            <Route path="/silentrenew" component={null} />
            <Route path="/callback" component={null} />
            <Route path="/invalidaccess" component={InvalidAccess} />
            <Route path="/logout" component={LogOut} />
            <Route path="/internal" />
            {!trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE) && <Route component={PageNotFound} />}
        </Switch>
    </Router>
);